import script from "./RightTask.vue?vue&type=script&setup=true&lang=js"
export * from "./RightTask.vue?vue&type=script&setup=true&lang=js"

import "./RightTask.vue?vue&type=style&index=0&id=6c21b5be&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c21b5be"]])

export default __exports__